import { render, staticRenderFns } from "./promisePrescriptModal.vue?vue&type=template&id=46fa1097"
import script from "./promisePrescriptModal.vue?vue&type=script&lang=js"
export * from "./promisePrescriptModal.vue?vue&type=script&lang=js"
import style0 from "./promisePrescriptModal.vue?vue&type=style&index=0&id=46fa1097&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports